<ef-indirect-rate-rule
    [rates]="rateTypes$ | async"
    [costCenters]="costCenters$ | async"
    [items]="rules$ | async"
    [selectedError]="selectedError"
    (ShowError)="ShowError.next($event)"
    (SelectRate)="SelectRate.next($event)"
    (SelectCostCenter)="SelectCostCenter.next($event)"
></ef-indirect-rate-rule>
